import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {Table} from 'reactstrap';

class ReligionList extends Component {
	
	/** set property value **/
	 constructor(props){
		super(props);
		this.state = {
		  _message : '',
		  alertClass :'',
		  id : '',
		  shown : false,
		  _redirect : false,
		  showReply: false,
		  posts: []
		}
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	} 
	
	/** this function will be call when page loading **/
	 componentDidMount() {
		 
		this.getdata();
	  }
	
	getdata(){
		
		GetData('caste/getreligion').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('caste/deletereligion',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Religion Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Subject',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/settings/religionupdate/' + this.state.idd} />);

	}
	
    return (
		<Table responsive bordered>
			<thead>
				<tr>
					<th>S.No</th>
					<th>Religion</th>
					<th width="100">Manage</th>
				</tr>
			</thead>
			<tbody>
				{this.state.posts.map(item =>
				 
					<tr key = {item}>
						<td>{item.id}</td>
						<td>{item.religion}</td>
						<td>
							<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button>
							&nbsp;&nbsp;
							<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} data-toggle="tooltip" data-placement="top" title="Delete"><i className="fa fa-remove"></i></button>
						</td>
					</tr>
	  
				 )}
			</tbody>
		</Table>
    );
  }
}

export default ReligionList;



// WEBPACK FOOTER //
// ./src/settings/Religion/ReligionList.js